import React, { Component } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Image from "react-bootstrap/Image";
import { PopupIconButtonReusable } from "./allPopupReusableIconButton/PopupIconButtonReusable";
import { PopupActionButton } from "../buttonReusableComponent/ButtonReusableComponent";
import EnterTableNumber from "./tableNumberPopup/EnterTableNumber";
import DeletePopup from "./smallPopup/DeletePopup";

export class RequestAcceptAndCancelled extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  render() {
    const { open } = this.state;
    return (
      <div className="notification-absolute-section">
        {this.props.displayButton === true ? (
          <Image
            src={require("../../../assets/images/ActionImages/remove.svg")}
            fluid
            alt="Reservation"
            title="Reservation"
            className="remove-button request-accept-cancelled"
            onClick={this.onOpenModal}
          />
        ) : (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass="cancel"
            onClick={this.onOpenModal}
          />
        )}

        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "customModal-request-accept-cancelled",
            closeButton: "customCloseButton",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="top-request-accept-cancelled-header">
            <h4>{this.props.bigText}</h4>
          </div>
          <div className="w-100 request-accept-cancelled">
            <div className="row menu-link-css">
              <div className="col">Name</div>
              <div className="col">Total</div>
              <div className="col">Timer</div>
            </div>
            <div className="request-accept-cancelled-border">
              <div className="row">
                <span className="col text-left small-text-reuse black-color">
                  #1234567890
                </span>
              </div>
              <div className="row request-accept-cancelled-top">
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                  <div className="d-flex ">
                    <Image
                      fluid
                      src={require("../../../assets/images/ActionImages/walking-img.svg")}
                      alt="Order Type"
                      title="Order Type"
                    />
                    <p className="big-text-reuse green-color">Shubham</p>
                  </div>
                </div>
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 request-accept-cancelled-center">
                  <div className="row">
                    <div className="col p-0">
                      <p>30</p>
                      <span className="">PAX</span>
                    </div>
                    <div className="col p-0">
                      <div className="d-flex align-items-center mb-2">
                        <Image
                          src={require("../../../assets/images/ActionImages/employees.png")}
                          fluid
                          alt="Adult"
                          title="Adult"
                          className="icon-image"
                        />
                        <span className="">11</span>
                      </div>
                      <div className="d-flex align-items-center ">
                        <Image
                          src={require("../../../assets/images/ActionImages/children.png")}
                          fluid
                          alt="Children"
                          title="Children"
                          className="icon-image"
                        />
                        <span className="">19</span>
                      </div>
                    </div>
                    <div className="col p-0">
                      <div className="d-flex align-items-center mb-2">
                        <Image
                          src={require("../../../assets/images/ActionImages/highchair.png")}
                          fluid
                          alt="Highchair"
                          title="Highchair"
                          className="icon-image-small"
                        />
                        <span className="">05</span>
                      </div>
                      <div className="d-flex align-items-center">
                        <Image
                          src={require("../../../assets/images/ActionImages/wheelchair.png")}
                          fluid
                          alt="Wheel Chair"
                          title="Wheel Chair"
                          className="icon-image-small"
                        />
                        <span className="">01</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 request-accept-cancelled-right">
                  <p className="big-text-reuse gray-color pb-3">Wait time</p>
                  <div className="d-flex justify-content-center">
                    <div>
                      <p className="time-run">00:08:32</p>
                      <span>HH:MM:SS</span>
                    </div>
                    <div className="img-div">
                      <Image
                        src={require("../../../assets/images/ActionImages/edit.png")}
                        fluid
                        alt="Wait time edit"
                        title="edit"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/*******************************
               * @DESC Middle Section One
               *******************************/}
              <div className="row middle-one-section">
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                  <p className="big-text-reuse gray-color pb-3">
                    Total Wait time
                  </p>
                  <div className="time-section">
                    <p className="big-text-reuse black-color">
                      00 <span className="small-text-reuse gray-color">HH</span>{" "}
                      : 00{" "}
                      <span className="small-text-reuse gray-color">mins</span>
                    </p>
                  </div>
                </div>
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 user-middle-section">
                  <p className="big-text-reuse gray-color pb-3">User</p>
                  <Image
                    fluid
                    src={require("../../../assets/images/ActionImages/maps-and-flags.svg")}
                    alt="Location"
                    title="Location"
                  />
                </div>
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                  <p className="big-text-reuse gray-color pb-3">Date</p>
                  <p className="big-text-reuse black-color">
                    25Th Aug,2020 07:30 AM
                  </p>
                </div>
              </div>

              {/*******************************
               * @DESC Middle Section Two
               ******************************/}
              <div className="row align-items-center">
                <div className="col-4 col-sm-4 col-md-3 col-lg-3 col-xl-3">
                  {this.props.leftButton === "unseat" ? (
                    <PopupActionButton
                      buttonText="Unseat"
                      buttonType="button"
                      buttonClass="cancel"
                    />
                  ) : null || this.props.leftButton === "cancel" ? (
                    <PopupActionButton
                      buttonText="Cancel"
                      buttonType="button"
                      buttonClass="cancel"
                    />
                  ) : null || this.props.leftButton === "reset" ? (
                    <PopupActionButton
                      buttonText="Reset"
                      buttonType="button"
                      buttonClass="cancel"
                    />
                  ) : null || this.props.leftButton === "notificationCancel" ? (
                    <DeletePopup
                      displayPopup="resonFforCancellation"
                      buttonDisplay="deleteButton"
                      buttonText="Cancel"
                      bigText="Are you sure to Cancel ?"
                    />
                  ) : null}
                </div>
                <div className="col-4 col-sm-4 col-md-6 col-lg-6 col-xl-6 middle-two-section">
                  <p className="big-text-reuse gray-color pb-2">
                    Seating Preferences
                  </p>
                  <span className="big-text-reuse black-color">Outdoor</span>
                </div>
                <div className="col-4 col-sm-4 col-md-3 col-lg-3 col-xl-3">
                  {this.props.rightButton === "complete" ? (
                    <PopupActionButton
                      buttonText="Complete"
                      buttonType="button"
                      buttonClass="save"
                    />
                  ) : null || this.props.rightButton === "seat" ? (
                    <PopupActionButton
                      buttonText="Seat"
                      buttonType="button"
                      buttonClass="save"
                    />
                  ) : null || this.props.rightButton === "notificationSeat" ? (
                    <EnterTableNumber buttonClass="save" buttonText="Seat" />
                  ) : null}
                </div>
              </div>

              {/*******************************
               * @DESC Middle Section Three
               *******************************/}
              <div className="middle-three-section">
                <PopupIconButtonReusable
                  buttonClass="bigButton"
                  image={require("../../../assets/images/ActionImages/phone-call.svg")}
                  titleText="Calling Button"
                />
                <div className="button-space">
                  <PopupIconButtonReusable
                    buttonClass="bigButton"
                    image={require("../../../assets/images/ActionImages/envelope.svg")}
                    titleText="Send Sms Button"
                  />
                </div>
                <PopupIconButtonReusable
                  buttonClass="bigButton"
                  image={require("../../../assets/images/ActionImages/view.svg")}
                  titleText="View Button"
                />
              </div>
              {/*******************************
               * @DESC Bottom Section
               *******************************/}
              <div className="row text-left">
                <div className="col pr-0">
                  <p className="big-text-reuse gray-color">Table / Room No.</p>
                  <p className="small-text-reuse gray-color">
                    Table No. : <span className="black-color"></span>
                  </p>
                  <p className="small-text-reuse gray-color">
                    Room No. : <span className="black-color">A-123</span>
                  </p>
                </div>
                <div className="col">
                  <p className="big-text-reuse gray-color">Special Occasion</p>
                  <p className="small-text-reuse black-color">
                    Graduation 20th Anniversary and my Dog’s Birthday…..
                  </p>
                </div>
                <div className="col">
                  <p className="big-text-reuse gray-color">Status</p>
                  <p className="big-text-reuse orange-color">
                    {this.props.status}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default RequestAcceptAndCancelled;
